import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "version" }
const _hoisted_2 = { class: "router-body" }
const _hoisted_3 = { class: "router-header" }

import defaultConfig from '@/configs/default.config'
import { nextTick, onMounted, ref } from 'vue'
import HMenu from '@/components/layout/SiderMenu.vue'
import HHeader from '@/components/layout/ConsoleHeader.vue'
import { useAppStore, useDataStore, useUserStore } from '@/store'


export default /*@__PURE__*/_defineComponent({
  __name: 'BasicLayout',
  setup(__props) {

const appStore = useAppStore()
const dataStore = useDataStore()
const userStore = useUserStore()
const { version } = defaultConfig
const collapsed = ref(false)
const consoleContentRef = ref()

const onCollapsed = (e: boolean) => {
  collapsed.value = e
}

const getGradeList = async () => {
  const list = await dataStore.getGradeList({ Limit: 9999, Offset: 0 })
  const vlist = list.map(x => {
    return {
      label: x.name,
      value: x.id
    }
  })

  dataStore.$patch({
    gradeOptions: vlist
  })
}

const getSchoolList = async () => {
  const list = await dataStore.getSchoolList({ Limit: 9999, Offset: 0 })
  const vlist = list.map(x => {
    return {
      label: x.name,
      value: x.id
    }
  })

  dataStore.$patch({
    schoolOptions: vlist
  })
}

document.documentElement.style.fontSize = document.documentElement.clientWidth / 19.2 + 'px'

onMounted(() => {
  nextTick(() => {
    appStore.setDeviceContentHeight(consoleContentRef.value.offsetHeight - 10)
    appStore.setDeviceContentWidth(consoleContentRef.value.offsetWidth)

    dataStore.getAllRoleList().then()

    if (userStore.userInfo?.schoolId) {
      getGradeList()
    }

    if (userStore.userInfo?.roleIds.includes(2)) {
      getSchoolList()
    }

  })
})


return (_ctx: any,_cache: any) => {
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { style: {"height":"100vh"} }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_sider, {
        collapsed: collapsed.value,
        "onUpdate:collapsed": _cache[0] || (_cache[0] = ($event: any) => ((collapsed).value = $event)),
        collapsible: "",
        trigger: null
      }, {
        default: _withCtx(() => [
          _createVNode(HMenu),
          _createElementVNode("div", _hoisted_1, "版本：" + _toDisplayString(_unref(version)), 1)
        ]),
        _: 1
      }, 8, ["collapsed"]),
      _createVNode(_component_a_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout_content, { style: {"margin":"0 16px"} }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(HHeader, { onCollapsed: onCollapsed })
                ]),
                _createElementVNode("div", {
                  class: "router-content",
                  ref_key: "consoleContentRef",
                  ref: consoleContentRef
                }, [
                  _createVNode(_component_router_view)
                ], 512)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})